import React from 'react';
interface StatProps {
  label: string;
  value: number;
  className?: string;
}

const Stat: React.FC<StatProps> = ({ label, value, className }) => (
  <div className={`flex items-center space-x-1 md:space-x-2 ${className}`}>
    <span className={`font-[800] ${className}`}>{value}</span>
    <span className={className}>{label}</span>
  </div>
);

export default Stat;
